module.exports = __webpack_public_path__ + "static/media/durian.39baa848.svg";